import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RegistrationFormRoutingModule } from "./registration-form-routing.module";
import { RegistrationFormComponent } from "./registration-form/registration-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedUtilityModule } from "src/app/shared-utility/shared-utility.module";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { PhysicianLocaleFormComponent } from "./physician-locale-form/physician-locale-form.component";
import { PrimeNgComponentsModule } from "src/app/prime-ng-components/prime-ng-components.module";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { RegistrationCompleteComponent } from "./registration-complete/registration-complete.component";
import { RegistrationBreadCrumbComponent } from "./registration-bread-crumb/registration-bread-crumb.component";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { NumberformatDirective } from "./registration-form/numberformat.directive";
import { NumberonlyDirective } from "src/app/shared-utility/common/numberonly.directive";
import { NgSelectModule } from "@ng-select/ng-select";
import { PopupModule } from "src/app/components/common/popup/popup.module";
@NgModule({
  declarations: [
    RegistrationFormComponent,
    PhysicianLocaleFormComponent,
    RegistrationCompleteComponent,
    RegistrationBreadCrumbComponent,
  ],
  imports: [
    CommonModule,
    RegistrationFormRoutingModule,
    ReactiveFormsModule,
    SharedUtilityModule,
    PrimeNgComponentsModule,
    NgSelectModule,
    FormsModule,
    PopupModule,
    PdfJsViewerModule
  ],
  exports: [RegistrationBreadCrumbComponent],
  entryComponents: [PhysicianLocaleFormComponent],
})
export class RegistrationFormModule { }
